<template>
    <div class="footer mg-top-20">
            {{footsystem.name}}  @技术支持  中微信通 <br />
            联系人电话：{{footsystem.tel}}  邮编：1000035<br />
            {{footsystem.bah}}  公安网安备110112119号
    </div>
</template>
<style>
    @import url('../assets/css/index.css');
    @import url('../assets/css/pubcss.css');
    
</style>
<script>
     export default {
        name: 'Foot',
        data () {
            return {
                footsystem: '', //底部数据
            }
        },
        mounted() {
            this.baseUrl = window.baseUrl;
            this.config = window.config;
            this.footData();
        },
        methods: {
            footData: function(){
                var that = this;
                that.$http.post(that.baseUrl+that.config.system).then(function(ev){
                    if(ev.data.code == 100){
                        that.footsystem = ev.data.data;
                    }
                }).catch(function(error){
                    console.log(error);
                })
            }
        },
        created() {

        },
    }
</script>


// WEBPACK FOOTER //
// src/components/myFoot.vue